module.exports = {
    get: function (name, json = false) {
        var data = localStorage.getItem(name)
        if (data) {
            return json ? JSON.parse(data) : data
        } else {
            return this.models[name] ? this.models[name] : ""
        }
    },
    getBool: function (name, isNulData = false) {
        var data = localStorage.getItem(name)
        return data ? (data == true) : isNulData
    },
    models: {
        tmpExperienceSpecialization: { id: '', title: '' },
        tmpExperienceLocation: {
            address: '',
            lat: 0,
            lng: 0,
        },
        tmpEducationSpecialization: { id: '', title: '' },
        tmpEducationLocation: {
            address: '',
            lat: 0,
            lng: 0,
        },
        tmpEducationDegree: { id: '', title: '' },
        cv_address: {
            address: '',
            lat: 0,
            lng: 0,
        },
        cv_job_stack: {
            id: 0,
            title: "",
            sallery: 0
        },
        cv_job_stack_currency: {
            id: 0,
            symbol: "",
            step: 1,
            max: 0
        },
        cv_theme: {
            id: 0,
            class_name: null,
        },
        cv_experiences: [],
        cv_educations: [],
        cv_languages: [],
        cv_professions: [],
        cv_skills: [],
        cv_socials: [],
        cv_hobbies: [],
        tmpSocial: {
            icon: null,
            url: '',
            class_name:''
        },
    }

}



// WEBPACK FOOTER //
// ./resources/js/helpers/LocaleCache.js